module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Serpent Warrior")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#synopsis"
    }
  }, [_vm._v("Synopsis")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#waking-the-sleeping-serpent"
    }
  }, [_vm._v("1 Waking the Sleeping Serpent")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#alliance-with-the-hun-and-earliest-memories"
    }
  }, [_vm._v("2 Alliance with the Hun and Earliest Memories")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#the-cruelty-of-the-innocent-and-the-great-surprise"
    }
  }, [_vm._v("3 The Cruelty of the Innocent and the Great Surprise")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#the-blessings"
    }
  }, [_vm._v("4 The Blessings")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#a-visit-to-the-hun",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 A Visit to the Hun")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-first-lessons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 The First Lessons")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#first-contact-with-the-pa-ra-lati",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 First Contact with the Pa-Ra-Lati")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#tihanna",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Tihanna")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#secrets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Secrets")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#first-kill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 First Kill")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-horse-whipping",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Horse Whipping")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#winds-of-change",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Winds of Change")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#goodbye-old-friend",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Goodbye Old Friend")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#a-light-in-the-darkness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 A Light in the Darkness")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#the-dweller-on-the-threshold",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 The Dweller on the Threshold")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#the-proposal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 The Proposal")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#painful-memories",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Painful Memories")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#no-holds-barred",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 No Holds Barred")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#initiation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Initiation")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#complex-dualities",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Complex Dualities")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#the-power-of-attraction",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 The Power of Attraction")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#initiations-and-tribulations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Initiations and Tribulations")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#the-sentence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 The Sentence")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#the-ritual-of-the-sacred-serpent",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 The Ritual of the Sacred Serpent, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Part 1")])])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#ritual-of-the-sacred-serpent",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 Ritual of the Sacred Serpent, "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Part 2")])])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#classified-information",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 Classified Information")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#a-cruel-twist-of-fate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 A Cruel Twist of Fate")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#my-shamanic-angel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 My Shamanic Angel")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#a-moral-code",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 A Moral Code")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#a-leap-of-faith",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 A Leap of Faith")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#time-to-come-out",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 Time to Come Out")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#gehenna",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32 Gehenna")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#farewell-garenhir",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33 Farewell Garenhir")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#the-truth-will-out",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34 The Truth Will Out")])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#dreams-and-visions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35 Dreams and Visions")])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#my-final-nemesis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36 My Final Nemesis")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0